import React from 'react';
import SplitButton from '../../input/SplitButton.component';
import {TASK_ACTIONS, DETAILS_VIEW_TYPE, DOCUMENT_ACTIONS} from "utils/constants.js";
import {Tooltip} from "../../tooltip/Tooltip";
import {eventBus} from "../../pagelayout/EventBus";
import {getTaskPreviewTooltip} from "utils/tooltips.js";
import {useNavigate} from "react-router-dom";
import {Button, ButtonType} from "components/common/Button.component";
import {Info} from "lucide-react";
import {ICON_SIZE} from "components/common/constants";
import { SHARED_TOOLTIP_ID } from "components/tooltip/AppTooltip.component";

export const TaskDetailsButtons = ({
                                       actions,
                                       selectedTaskKeys,
                                       action,
                                       translate,
                                       userSettings,
                                       openEditorPopup,
                                       isReadOnly,
                                       disableAll,
                                       documentVersion,
                                       task,
                                       taskDetails,
                                       hasDraftComment
                                   }) => {
    const editorAllowed = !!openEditorPopup;
    let isApproveEnabled = actions.isEnabled(TASK_ACTIONS.APPROVE);
    let isApproveAndBatchEnabled = actions.isEnabled(TASK_ACTIONS.APPROVE_BATCH);
    let isApprovePaymentEnabled = isApproveAndBatchEnabled;

    let isRejectEnabled = actions.isEnabled(TASK_ACTIONS.REJECT);
    let editorTranslation = isReadOnly ? "taskDetail.actionBar.view" : "taskDetail.actionBar.edit";
    let approveLabel = userSettings.showCommentOnApprove ? "..." : '';

    const navigate = useNavigate();

    const hasUnevaluatedLines = taskDetails.taskPermission?.hasLinesNotEvaluated;

    let actionList = actions.getSplitButtons().map((actionItem) => {

            // split button item
            const res = {
                type: actionItem.type,
                active: actionItem.active,
                shortKey: actionItem.shortKey,
                onClick: () => {
                    action(actionItem.type, selectedTaskKeys);
                },
                label: translate("taskDetail.actionBar." + actionItem.type)
            };
            return res;
        }
    );

    let approveAndSignActions = [];

    if (isApproveAndBatchEnabled) {
        approveAndSignActions = actions.getApproveAndBatchSplitButtons();
    }

    let approveAndSignList = approveAndSignActions.map((actionItem) => {
        // split button item
        const res = {
            type: actionItem.type,
            active: actionItem.active,
            shortKey: actionItem.shortKey,
            onClick: () => {
                action(actionItem.type, selectedTaskKeys);
            },
            label: translate("taskDetail.actionBar." + actionItem.type),
            tooltip: translate("taskDetail.actionBar." + actionItem.type + "Tooltip")
        };
        return res;
    });

    let addToBundle = function () {
        action(TASK_ACTIONS.APPROVE_BATCH, selectedTaskKeys);
    };

    const tooltipPreview = getTaskPreviewTooltip({
        pastActions: taskDetails.pastActions,
        actorType: task.actorType,
        taskAssignmentType: task.taskAssignmentType
    }, translate);

    return (
        <div
            className={"d-flex align-items-center justify-content-end "}>
            <div className="d-flex align-items-center gap-8">
                {tooltipPreview.length === 0 ? null :
                    <div>
                        <span className="cursor-pointer"
                              data-for={SHARED_TOOLTIP_ID} data-tip={"preview-tooltip"}>
                                         <Info size={ICON_SIZE.MEDIUM} className="me-3 mt-2"/>
                        </span>
                        <Tooltip
                            id={"preview-tooltip"}
                            content={() => <PreviewTooltip translate={translate}
                                                           content={tooltipPreview}
                            />}
                        />
                    </div>}

                {isApprovePaymentEnabled &&
                    <SplitButton
                        id="ApproveAndSignSplitButton"
                        hasDefaultAction={true}
                        defaultAction={addToBundle}
                        translate={translate}
                        tooltip={translate("taskDetail.actionBar.batchTooltip")}
                        initialLabel={translate("taskDetail.actionBar.approveAndBatch")}
                        actions={approveAndSignList}
                        disabled={disableAll}
                        type={ButtonType.PRIMARY}
                    />
                }

                {!isApprovePaymentEnabled &&
                    <Button
                        type={ButtonType.PRIMARY}
                        onClick={() => {
                            action(TASK_ACTIONS.APPROVE, selectedTaskKeys, {
                                documentVersion,
                                hasUnevaluatedLines,
                                hasDraftComment,
                                navigate
                            });
                        }}
                        disabled={disableAll || !isApproveEnabled}
                        text={translate("taskDetail.actionBar.approve") + approveLabel}
                        dataCy={"taskDetail.actionBar.approve"}
                    />

                }
                {isRejectEnabled &&
                    <Button
                        type={ButtonType.SECONDARY}
                        onClick={() => {
                            action(TASK_ACTIONS.REJECT, selectedTaskKeys, {navigate});
                        }}
                        disabled={disableAll}
                        text={translate("taskDetail.actionBar.reject")}
                        dataCy={"taskDetail.actionBar.reject"}
                    />
                }

                {editorAllowed &&
                    <Button
                        type={ButtonType.SECONDARY}
                        onClick={openEditorPopup}
                        disabled={disableAll}
                        text={translate(editorTranslation)}
                        dataCy={"taskDetail.actionBar.edit"}
                    />
                }
                <SplitButton
                    id="task-detail-split-button"
                    initialLabel={translate('taskDetail.actionBar.other')}
                    actions={actionList}
                    disabled={disableAll}
                />
            </div>
        </div>

    )
};


const TaskReviewDetailsButtons = ({
                                      actions,
                                      selectedTaskKeys,
                                      action,
                                      translate,
                                      task,
                                      taskDetails,
                                      disableAll
                                  }) => {
    const tooltipPreview = getTaskPreviewTooltip({
        pastActions: taskDetails.pastActions,
        actorType: task.actorType,
        taskAssignmentType: task.taskAssignmentType
    }, translate);

    const navigate = useNavigate();

    let actionList = actions.getReviewTaskSplitButtons().map((actionItem) => {
            // split button item
            const res = {
                type: actionItem.type,
                active: actionItem.active,
                shortKey: actionItem.shortKey,
                onClick: () => {
                    action(actionItem.type, selectedTaskKeys, {navigate});
                },
                label: translate("taskDetail.actionBar." + actionItem.type)
            };
            return res;
        }
    );

    return (
        <div className="subnavbar-task-action-buttons d-flex align-items-center justify-content-end">
            <div className="d-flex align-items-center justify-content-end gap-8" role={"menubar"}>
                {tooltipPreview.length === 0 ? null :
                    <div>
                        <span className="cursor-pointer"
                              data-for={SHARED_TOOLTIP_ID} data-tip={"preview-tooltip"}>
                            <Info size={ICON_SIZE.MEDIUM} className="me-3 mt-2"/>
                        </span>
                        <Tooltip
                            id={"preview-tooltip"}
                            content={() => <PreviewTooltip translate={translate}
                                                           content={tooltipPreview}
                            />}
                        />
                    </div>}
                <Button
                    type={ButtonType.PRIMARY}
                    onClick={() => {
                        action(TASK_ACTIONS.REVIEW, selectedTaskKeys, {navigate});
                    }}
                    disabled={disableAll}
                    text={translate("taskDetail.actionBar.review")}
                />
                <SplitButton
                    id="task-detail-split-button"
                    initialLabel={translate('taskDetail.actionBar.other')}
                    useGaiaStyles={true}
                    bsClass={"float-right m-0"}
                    actions={actionList}
                    disabled={disableAll}
                />
            </div>

        </div>
    )
};

//TO DO styling
const DocumentDetailButtons = ({
                                   actions,
                                   selectedTaskKeys,
                                   action,
                                   translate,
                                   openEditorPopup,
                                   isReadOnly,
                                   disableAll
                               }) => {

    const editorAllowed = !!openEditorPopup;
    const allDisabledClass = disableAll ? "disabled" : "";
    let isSendForApprovalEnabled = actions.isEnabled(DOCUMENT_ACTIONS.SEND_FOR_APPROVAL);
    let editorTranslation = isReadOnly ? "taskDetail.actionBar.view" : "taskDetail.actionBar.edit";
    const navigate = useNavigate();

    let actionList = actions.getDocumentSplitButtons().map((actionItem) => {

            // split button item
            const res = {
                type: actionItem.type,
                active: actionItem.active,
                shortKey: actionItem.shortKey,
                onClick: () => {
                    action(actionItem.type, selectedTaskKeys, {navigate});
                },
                label: translate("taskDetail.actionBar." + actionItem.type)
            };
            return res;
        }
    );

    return (
        <div
            className={"d-flex align-items-center justify-content-end " + allDisabledClass}>
            <div className="d-flex gap-8">
                <SplitButton
                    id="task-detail-split-button"
                    initialLabel={translate('taskDetail.actionBar.other')}
                    useGaiaStyles={true}
                    bsClass={"float-right m-0"}
                    actions={actionList}
                    isDetails={true}
                    disabled={disableAll}
                />
                {editorAllowed &&
                    <Button
                        type={ButtonType.SECONDARY}
                        onClick={openEditorPopup}
                        disabled={disableAll}
                        text={translate(editorTranslation)}
                    />
                }

                {isSendForApprovalEnabled &&
                    <Button
                        type={ButtonType.PRIMARY}
                        onClick={() => {
                            action(DOCUMENT_ACTIONS.SEND_FOR_APPROVAL, selectedTaskKeys, {navigate});
                        }}
                        disabled={disableAll}
                        text={translate("documentOverview.actions.sendForApproval")}
                    />
                }

            </div>
        </div>
    )
};

const PreviewTooltip = ((props) => {

    const openWorkflowPanel = (event) => {
        event.preventDefault();
        eventBus.dispatch("openWorkflowPanel")
    }

    return (<div>
        <div className="ga-tooltip__title">
            {props.translate('myTasks.reapprovalTooltip.title')}
        </div>
        {props.content.length === 1 ?
            <div>
                {props.content}
            </div> :
            <ul>
                {props.content.map((item, index) => {
                    return <li key={`preview-tooltip-item-${index}`}>{item}</li>
                })}
            </ul>}
        <div className="mb-3">
            {props.translate('myTasks.reapprovalTooltip.openPanel') + ' '}
            <a className="ga-link" href="#" onClick={openWorkflowPanel}>{props.translate('myTasks.reapprovalTooltip.workflowDetails')}</a>
            {' ' + props.translate('myTasks.reapprovalTooltip.forMoreInfo')}
        </div>
    </div>);
});

const TaskActionButtons = (props) => {
    if (props.actions.isEnabled(TASK_ACTIONS.REVIEW)) {
        return TaskReviewDetailsButtons(props);
    } else if (props.docType === DETAILS_VIEW_TYPE.TASK) {
        return TaskDetailsButtons(props);
    } else {
        return DocumentDetailButtons(props);
    }
};

export default TaskActionButtons;
